import PropTypes from "prop-types";
import React from "react";
import Icon from "@xo-union/tk-component-icons";
import { Body1 } from "@xo-union/tk-ui-typography";
import styles from "./styles.css";
import SharedBanner from "../shared/banner/index.js";
export default function FilteredResultsBanner(_ref) {
  var bannerText = _ref.bannerText,
    actionText = _ref.actionText,
    handleClose = _ref.handleClose,
    animation = _ref.animation,
    isVisibile = _ref.isVisibile,
    handleClick = _ref.handleClick;
  return /*#__PURE__*/React.createElement(SharedBanner, {
    animation: animation,
    isVisibile: isVisibile,
    isMobileOnly: true,
    dataTestId: "filtered-results-banner"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.leftSide
  }, /*#__PURE__*/React.createElement(Body1, {
    as: "p",
    "data-testid": "banner-text"
  }, bannerText, ' ', /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: handleClick
  }, actionText))), /*#__PURE__*/React.createElement("div", {
    className: styles.rightSide
  }, /*#__PURE__*/React.createElement("button", {
    color: "tertiary-alternative",
    size: "md",
    type: "button",
    className: styles.closeButton,
    onClick: handleClose,
    "data-testid": "close-button"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "close",
    size: "md",
    className: styles['close-icon']
  }))));
}
process.env.NODE_ENV !== "production" ? FilteredResultsBanner.propTypes = {
  bannerText: PropTypes.string,
  actionText: PropTypes.string,
  handleClose: PropTypes.func.isRequired,
  animation: PropTypes.string.isRequired,
  isVisibile: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired
} : void 0;
FilteredResultsBanner.defaultProps = {
  bannerText: 'We’ve set filters based on your quiz.',
  actionText: 'Adjust filters.'
};